export const MOODS = [
  { key: "gestresst", label: "Gestresst", dot: "bg-red-600" },
  { key: "neutraal", label: "Neutraal", dot: "bg-zinc-400" },
  { key: "ontspannen", label: "Ontspannen", dot: "bg-emerald-600" },
];

export const moodMeta = (key) => MOODS.find((m) => m.key === key);

export const MoodBadge = ({ mood, testid }) => {
  const m = moodMeta(mood?.mood);
  if (!m) return null;
  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-zinc-700" title={`Laatst bijgewerkt ${new Date(mood.updated_at).toLocaleDateString("nl-NL")}`} data-testid={testid}>
      <span className={`h-2 w-2 rounded-full ${m.dot}`} /> {m.label}
    </span>
  );
};
